import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { HelpTicket } from '@shared/models/help-ticket.model';
import { ICatalog } from '@shared/models/icommons.model';
import { L10nTranslationService } from 'angular-l10n';

const TICKET_STATUS_DEPLOYED_TO_PRODUCTION = 'DEPLOYED TO PRODUCTION';
const TICKET_STATUS_SCHEDULED_FOR_RELEASE = 'SCHEDULED FOR RELEASE';

@Component({
  selector: 'miq-ticket-detail-status',
  templateUrl: './ticket-detail-status.component.html',
  styleUrls: ['./ticket-detail-status.component.scss'],
  standalone: false,
})
export class TicketDetailStatusComponent implements OnInit {
  @Input()
  public ticketDetail: HelpTicket;
  @Input()
  public ticketStatuses: ICatalog[];
  @Input()
  public isProfile: boolean;
  @Input()
  public isInGroup: boolean;
  @Output()
  public statusChangeEvent = new EventEmitter<number>();

  public selectedActionStatusCtrl = new UntypedFormControl();
  public actionStatuses: ICatalog[];
  public actionStatusesValue = ['SCHEDULED FOR RELEASE', 'ON HOLD', 'NOT ON ROADMAP'];
  public deployedToProductionStatusId: number;

  public newChecked = false;
  public requirementDiscoveryChecked = false;
  public businessReviewChecked = false;
  public prioritizedChecked = false;
  public actionStatusChecked = false;
  public deployedToProdChecked = false;

  constructor(public translationService: L10nTranslationService) {}

  ngOnInit() {
    this.ticketStatuses.sort((a, b) => {
      let sortValue = 0;
      if (a.key < b.key) {
        sortValue = -1;
      } else if (a.key > b.key) {
        sortValue = 1;
      }
      return sortValue;
    });
    this.actionStatuses = this.ticketStatuses.filter(f => this.actionStatusesValue.includes(f.value.toUpperCase()));
    this.selectedActionStatusCtrl.setValue(this.getTicketStatusForDropDown());
    this.deployedToProductionStatusId = this.ticketStatuses.find(
      f => f.value.toUpperCase() === TICKET_STATUS_DEPLOYED_TO_PRODUCTION
    ).key as number;
    this.setStatusChecked(this.ticketDetail.statusId);

    this.selectedActionStatusCtrl.valueChanges.subscribe(statusId => {
      this.statusChangeEvent.emit(statusId);
    });
  }

  private setStatusChecked(ticketStatusId: number) {
    if (ticketStatusId === 1) {
      this.newChecked = true;
      this.requirementDiscoveryChecked = false;
      this.businessReviewChecked = false;
      this.prioritizedChecked = false;
      this.actionStatusChecked = false;
      this.deployedToProdChecked = false;
    } else if (ticketStatusId === 2) {
      this.newChecked = true;
      this.requirementDiscoveryChecked = true;
      this.businessReviewChecked = false;
      this.prioritizedChecked = false;
      this.actionStatusChecked = false;
      this.deployedToProdChecked = false;
    } else if (ticketStatusId === 3) {
      this.newChecked = true;
      this.requirementDiscoveryChecked = true;
      this.businessReviewChecked = true;
      this.prioritizedChecked = false;
      this.actionStatusChecked = false;
      this.deployedToProdChecked = false;
    } else if (ticketStatusId === 4) {
      this.newChecked = true;
      this.requirementDiscoveryChecked = true;
      this.businessReviewChecked = true;
      this.prioritizedChecked = true;
      this.actionStatusChecked = false;
      this.deployedToProdChecked = false;
    } else if (ticketStatusId >= 5 && ticketStatusId <= 7) {
      this.newChecked = true;
      this.requirementDiscoveryChecked = true;
      this.businessReviewChecked = true;
      this.prioritizedChecked = true;
      this.actionStatusChecked = true;
      this.deployedToProdChecked = false;
    } else if (ticketStatusId === 8) {
      this.newChecked = true;
      this.requirementDiscoveryChecked = true;
      this.businessReviewChecked = true;
      this.prioritizedChecked = true;
      this.actionStatusChecked = true;
      this.deployedToProdChecked = true;
    }
  }

  getTicketStatusForDropDown(): number {
    if (this.actionStatuses.find(f => f.key === this.ticketDetail.statusId)) {
      return this.ticketDetail.statusId;
    }
    return this.actionStatuses.find(f => f.value.toUpperCase() === TICKET_STATUS_SCHEDULED_FOR_RELEASE).key as number;
  }

  statusChange(_$event, statusId) {
    event.preventDefault();
    this.setStatusChecked(statusId);
    this.statusChangeEvent.emit(statusId);
  }
}
